/*
* 包含 n 个mutation的type常量
* */

const types = {
  INDEXBLOCKLIST: 'indexBlocks',
  MARKETINFO: 'marketInfo',
  INDEXTXNLIST: 'indexTxnList',

  BLOCKINFO: 'blockInfo',
  BLOCKDETAIL: 'blockDetail',

  TXNINFO: 'txnInfo',
  TXNDETAIL: 'txnDetail',

  ACCOUNTINFO: 'accountInfo',
  ACCOUNTDETAIL: 'accountDetail',
  ACCOUNTTXNINFO: 'accountTxnInfo',

}

export default types





// WEBPACK FOOTER //
// ./src/store/mutation_types.js